module.exports = __webpack_public_path__ + "static/img/testimony (45).91de3ec0.jpg";